export default "__VITE_ASSET__f60680e2__"